import React, {useState} from "react";
import PrivacyPolicyModal from "./PolicyTerms";
import TermsAndConditionsModal from "./TermsConditions";
import { Link } from "react-router";
export default function  Footer(){
    const [modalOpen, setModalOpen] = useState(false);
    const [termsmodalOpen, settermsModalOpen] = useState(false);
    return(

<>
  <section className="py-20 bg-gray-50">
    <div className="container px-4 mx-auto">
      <div className="max-w-7xl mx-auto">

        {/* Top Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-12">

          {/* About */}
          <div>
            <h4 className="text-lg font-semibold text-gray-800 mb-4">
              CHICALAC
            </h4>
            <p className="text-sm text-gray-500 leading-relaxed">
              Child Care Legal Aid Clinic provides legal support, advocacy,
              and guidance to protect children and families.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-gray-800 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm text-gray-500 font-medium">
              <li>
                <Link to="/about" className="hover:text-gray-700">
                  About Us
                </Link>
              </li>
              
             
              <li>
                <Link to="/contact" className="hover:text-gray-700">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Buttons (Hybrid with Font Awesome) */}
          <div>
            <h4 className="text-lg font-semibold text-gray-800 mb-4">
              Follow Us
            </h4>
            <div className="flex flex-wrap gap-3">

              {/* Facebook */}
              <Link
                to="https://web.facebook.com/people/Child-Care-Legal-Aid-Clinic-CHICALAC/100064835043019/" // replace with real route or external link
                className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-full text-sm font-medium hover:bg-blue-700 transition"
              >
                <i className="fab fa-facebook-f"></i> Facebook
              </Link>

              {/* Twitter */}
              
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col lg:flex-row items-center gap-6">

            {/* Legal Links */}
            <div className="flex flex-wrap gap-4 text-sm font-semibold text-gray-500">
              <p onClick={() => setModalOpen(true)} className="hover:text-gray-600 cursor-pointer">
                Privacy Policy
              </p>
              <p onClick={() => settermsModalOpen(true)} className="hover:text-gray-600 cursor-pointer">
                Terms & Conditions
              </p>
            </div>

            {/* Copyright */}
            <span className="lg:ml-auto text-sm text-gray-500">
              © 2025–2050 Child Care Legal Aid Clinic (CHICALAC). All Rights Reserved.
            </span>
          </div>
        </div>

      </div>
    </div>
  </section>

  <PrivacyPolicyModal open={modalOpen} onClose={() => setModalOpen(false)} />
  <TermsAndConditionsModal open={termsmodalOpen} onClose={() => settermsModalOpen(false)} />
</>


    )
}